var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{attrs:{"app":""}},[_c('v-toolbar-title',[_c('BreadCrumb')],1),_c('v-spacer'),_vm._v(" "+_vm._s(_vm.getUserName)+" ")],1),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }